import { Component, DoCheck, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { TableCellComponent } from '@captiveaire/table';
import { FormatDeviceConfigurationPipe } from '@caslink/common-client/ng-app/formatDeviceConfiguration/FormatDeviceConfigurationPipe';
import { IDeviceStatusListSummary } from '../shared/models/device-status-list-summary.interface';

@Component({
    selector: 'dl-device-status-configuration-cell',
    templateUrl: './device-status-configuration-cell.component.html'
})
export class DeviceStatusConfigurationCellComponent extends TableCellComponent implements OnInit, DoCheck {
    public static $name: string = 'clDeviceStatusConfigurationCell';

    @Input() public item: IDeviceStatusListSummary;

    public configurationCellFormGroup: FormGroup;
    public configurationFormControl: FormControl;

    constructor(
        private formatDeviceConfigurationPipe: FormatDeviceConfigurationPipe,
    ) {
        super();
    }

    public ngDoCheck() {
        if (this.isEditable) {
            this.configurationFormControl.enable();
        } else {
            this.configurationFormControl.disable();
        }
    }

    public ngOnInit() {
        this.configurationCellFormGroup = new FormGroup({});
        let initialValue = this.item.configuration ? this.item.configuration.Key : '';
        this.configurationFormControl = new FormControl(initialValue);
        this.configurationCellFormGroup.addControl('deviceConfigurations', this.configurationFormControl);
    }

    get isEditable(): boolean {
        return this.item.$isInEditMode
            && this.item !== null
            && this.item.configurations != null
            && this.item.configurations.length > 0;
    }

    public configurationChanged($event: MatSelectChange) {
        const selected = this.item.configurations.filter(configuration => configuration.id === $event.value);
        if (selected && selected.length === 1) {
            this.item.configuration = {
                Key: selected[0].id,
                Value: this.formatDeviceConfigurationPipe.transform(selected[0])
            };
            this.item.modbusId = selected[0].modbusDeviceId;
        }
    }
}
